import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import React from 'react';
import styled from 'styled-components';
var Section = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var Head = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 0.25rem;\n"])));
var Title = styled.h4(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin: 0;\n"])));
var Subtitle = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 0.9rem;\n  color: ", ";\n  margin-left: 1rem;\n"])), function (props) {
  return props.theme.colors.darkGrey;
});
var Action = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  text-align: right;\n"])));
var Body = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (props) {
  return props.margin;
});

var FormSection = function FormSection(_ref) {
  var _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      children = _ref.children,
      action = _ref.action,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      titleStyle = _ref.titleStyle,
      headStyle = _ref.headStyle;
  return /*#__PURE__*/React.createElement(Section, {
    id: id
  }, /*#__PURE__*/React.createElement(Head, {
    style: headStyle
  }, /*#__PURE__*/React.createElement(Title, {
    style: titleStyle
  }, title), subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle), action && /*#__PURE__*/React.createElement(Action, null, action)), /*#__PURE__*/React.createElement(Body, {
    margin: margin
  }, children));
};

export default FormSection;